const UserIcon = ({ color = 'currentColor' }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5 4C11.5 5.93386 9.93386 7.5 8 7.5C6.06614 7.5 4.5 5.93386 4.5 4C4.5 2.06614 6.06614 0.5 8 0.5C9.93386 0.5 11.5 2.06614 11.5 4ZM0.5 14C0.5 13.5186 0.737162 13.06 1.21364 12.6202C1.69352 12.1773 2.38208 11.7882 3.18469 11.4666C4.79071 10.8233 6.7275 10.5 8 10.5C9.2725 10.5 11.2093 10.8233 12.8153 11.4666C13.6179 11.7882 14.3065 12.1773 14.7864 12.6202C15.2628 13.06 15.5 13.5186 15.5 14V15C15.5 15.2739 15.2739 15.5 15 15.5H1C0.726142 15.5 0.5 15.2739 0.5 15V14Z"
        fill={color}
        stroke={color}
      />
    </svg>
  );
};

export default UserIcon;
